import { ViewModel,View } from "binder"
import { ElementDecorator, FormBuilderElement } from "src/formBuilder/structure/element";
import { getAsNumber } from "src/uicomponents/components/utilities";
import  { GridLocationDecoratorView } from "./gridLocationDecorator-view"

export class GridLocationDecoratorViewModel extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new GridLocationDecoratorView();
    }
    public getTypeId(): string {
        return "VM-59BEAA69-4523-4623-96B1-BC17AF85715E"
    }

    public set GridAttachedColumn(v: number) { this._GridAttachedColumn = getAsNumber(v,true); } public get GridAttachedColumn(): number { return this._GridAttachedColumn;} private _GridAttachedColumn: number;
    public set GridAttachedRow(v: number) { this._GridAttachedRow = getAsNumber(v,true); } public get GridAttachedRow(): number { return this._GridAttachedRow;} private _GridAttachedRow: number;
    public set GridAttahedColumnSpan(v: number) { this._GridAttahedColumnSpan = getAsNumber(v,true); } public get GridAttahedColumnSpan(): number { return this._GridAttahedColumnSpan;} private _GridAttahedColumnSpan: number;
    public set GridAttachedRowSpan(v: number) { this._GridAttachedRowSpan = getAsNumber(v,true); } public get GridAttachedRowSpan(): number { return this._GridAttachedRowSpan;} private _GridAttachedRowSpan: number;
    
}
